module.exports = __webpack_public_path__ + "img/signalizator_cover.f23ff36e.webp";